import { observer } from 'mobx-react-lite'
import type { NotesRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/notes/NotesRequestedSupportingItemViewModel'
import { WizardContentBody, WizardContentFooter } from '@/components/Wizard'
import { TaxInfoGatheringWizardContentButtonGroupContainer } from '@/features/jobs/details/tax-type/info-gathering/components/TaxInfoGatheringWizardContentButtonGroupContainer'
import type { TaxInfoGatheringViewModel } from '@/features/jobs/details/tax-type/info-gathering/TaxInfoGatheringViewModel'
import { NotesEditor } from '@/features/jobs/details/tax-type/info-gathering/notes/components/NotesEditor'
import { useId } from 'react'

interface NotesWizardContentContainerProps {
  itemVm: NotesRequestedSupportingItemViewModel
  taxInfoGatheringVm: TaxInfoGatheringViewModel
}

export const NotesWizardContentContainer = observer(
  function NotesWizardContentContainer({
    itemVm,
    taxInfoGatheringVm,
  }: NotesWizardContentContainerProps) {
    const formId = useId()
    const isCompleteInfoGatheringPending =
      taxInfoGatheringVm.confirmCompleteInfoGathering.pending

    return (
      <>
        <WizardContentBody>
          <NotesEditor
            vm={itemVm}
            formId={formId}
            isDisabled={isCompleteInfoGatheringPending}
          />
        </WizardContentBody>
        <WizardContentFooter>
          <TaxInfoGatheringWizardContentButtonGroupContainer
            variant="save"
            taxInfoGatheringVm={taxInfoGatheringVm}
            itemVm={itemVm}
            formId={formId}
            isSavePending={itemVm.save.pending}
          />
        </WizardContentFooter>
      </>
    )
  },
)
